import {
  GetCollaboratorAdvancementResponse,
  GetCollaboratorDetailsResponse,
  GetCollaboratorCarrerManagersResponse,
  GetCollaboratorsResponse,
  GetCollaboratorCmSheetsResponse,
  GetCollaboratorImageResponse,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetCollaboratorsResponse>(
      `v1/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async get(collaboratorId: number): Promise<GetCollaboratorDetailsResponse> {
    const response = await httpClient.get<GetCollaboratorDetailsResponse>(
      `v1/collaborators/${collaboratorId}`,
    );
    return response;
  },
  async getAdvancement(
    collaboratorId?: number,
  ): Promise<GetCollaboratorAdvancementResponse> {
    const response = await httpClient.get<GetCollaboratorAdvancementResponse>(
      `v1/collaborators/${collaboratorId}/advancements`,
    );
    return response;
  },
  async getCollaboratorCmSheets(
    collaboratorId: number,
  ): Promise<GetCollaboratorCmSheetsResponse> {
    const response = await httpClient.get<GetCollaboratorCmSheetsResponse>(
      `v1/collaborators/${collaboratorId}/cm-sheets`,
    );
    return response;
  },
  async getCollaboratorCarrerManagers(
    collaboratorId?: number,
  ): Promise<GetCollaboratorCarrerManagersResponse> {
    const response =
      await httpClient.get<GetCollaboratorCarrerManagersResponse>(
        `v1/collaborators/${collaboratorId}/career-managers`,
      );
    return response;
  },
  async modifyCollaboratorCM(
    collaboratorId?: number,
    careerManagerId?: number,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/career-managers/${careerManagerId}`,
    );
  },
  async getImage(
    collaboratorId: number,
  ): Promise<GetCollaboratorImageResponse> {
    const response = await httpClient.get<GetCollaboratorImageResponse>(
      `v1/collaborators/${collaboratorId}/image`,
    );
    return response;
  },
  async deleteCollaboratorCM(
    collaboratorId: number,
    careerManagerId: number,
  ): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/career-managers/${careerManagerId}`,
    );
  },
};

export default CollaboratorsService;
